$(document).ready(() => {
    $('#add-intervenant').click(function() {
        var currentCount = $('.form-intervenant').length;
        var template = $('#template-intervenant').data('template');
        template = template.replace(/__placeholder__/g, currentCount);

        $('#fieldset-intervenant > fieldset').append(template);
        return false;
    });

    $('form').on('click', '.delete-intervenant', function(){
        //console.log('click');
        var div = $(this).closest('fieldset').remove();
    });
});
